var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.deleted && this.prize.deletedAt == null
      ? _c("div", { staticClass: "flex-table-row d-flex align-items-center" }, [
          _c(
            "div",
            {
              staticClass: "column c-prize-name",
              style: {
                textDecoration:
                  this.prize.status == "drawn" ? "underline" : "none",
                cursor: this.prize.status == "drawn" ? "pointer" : "auto"
              }
            },
            [_vm._v(_vm._s(this.prize.name))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "column c-status" }, [
            !this.prize.drawn && this.prize.draws.length <= 0
              ? _c("div", { staticClass: "dropdown" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("ul", { staticClass: "dropdown-menu start-draw" }, [
                    _c("li", [
                      _c(
                        "button",
                        {
                          staticClass: "btn",
                          on: {
                            click: function($event) {
                              return _vm.startPublicDraw()
                            }
                          }
                        },
                        [_vm._v("Public")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "button",
                        {
                          staticClass: "btn",
                          on: {
                            click: function($event) {
                              return _vm.startDraw()
                            }
                          }
                        },
                        [_vm._v("Private")]
                      )
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            !this.prize.drawn && this.prize.draws.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "alert alert-secondary",
                    attrs: { role: "alert" }
                  },
                  [_vm._v("in progress")]
                )
              : _vm._e(),
            _vm._v(" "),
            this.prize.drawn
              ? _c(
                  "div",
                  {
                    staticClass: "alert alert-success",
                    attrs: { role: "alert" }
                  },
                  [_vm._v("drawn")]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "column c-list block-with-text mobile",
              attrs: {
                title: this.prize.lists
                  .map(function(i) {
                    return i.name
                  })
                  .join(", ")
              }
            },
            [
              _vm._v(
                _vm._s(
                  this.prize.lists
                    .map(function(i) {
                      return i.name
                    })
                    .join(", ")
                )
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "column c-winners mobile" }, [
            _vm._v(_vm._s(this.prize.winnerCount))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column type-date c-created mobile" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.formatDate(this.prize.createdAt)) +
                "\n      "
            ),
            _c("span", [_vm._v(_vm._s(_vm.formatTime(this.prize.createdAt)))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column type-date c-modified mobile" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.formatDate(this.prize.updatedAt)) +
                "\n      "
            ),
            _c("span", [_vm._v(_vm._s(_vm.formatTime(this.prize.updatedAt)))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column c-modified-by mobile" }, [
            _c("div", [_vm._v(_vm._s(this.prize.author.gevmeUser.firstname))]),
            _vm._v(" "),
            _c("div", { staticStyle: { "margin-top": "7px" } }, [
              _vm._v(_vm._s(this.prize.author.gevmeUser.email))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column c-action" }, [
            _c("div", { staticClass: "btn-group" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "dropdown-menu dropdown-menu-right prize-list-actions"
                },
                [
                  this.prize.drawn
                    ? _c(
                        "button",
                        {
                          staticClass: "dropdown-item",
                          on: {
                            click: function($event) {
                              return _vm.viewDrawSummary()
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: { src: require("@/assets/images/eye.svg") }
                          }),
                          _vm._v("\n            View Draw Summary\n          ")
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !this.prize.drawn && this.prize.draws.length <= 0
                    ? _c(
                        "button",
                        {
                          staticClass: "dropdown-item",
                          on: {
                            click: function($event) {
                              return _vm.editPrize()
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: { src: require("@/assets/images/edit.svg") }
                          }),
                          _vm._v("\n            Edit Prize\n          ")
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          return _vm.duplicatePrize()
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: { src: require("@/assets/images/duplicate.svg") }
                      }),
                      _vm._v("\n            Duplicate Prize\n          ")
                    ]
                  ),
                  _vm._v(" "),
                  this.prize.drawn
                    ? _c(
                        "button",
                        {
                          staticClass: "dropdown-item",
                          on: {
                            click: function($event) {
                              return _vm.exportAttendees(_vm.prize)
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/images/export.svg")
                            }
                          }),
                          _vm._v("\n            Export Attendees\n          ")
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !this.prize.drawn && this.prize.draws.length <= 0
                    ? _c(
                        "button",
                        {
                          staticClass: "dropdown-item",
                          on: {
                            click: function($event) {
                              return _vm.deleteModal()
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: { src: require("@/assets/images/trash.svg") }
                          }),
                          _vm._v("\n            Delete Prize\n          ")
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          return _vm.goToAuditHistory(
                            _vm.prize.id,
                            _vm.prize.name
                          )
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/images/audit-history.svg")
                        }
                      }),
                      _vm._v("\n            Audit History\n          ")
                    ]
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "modal fade",
              attrs: { id: _vm.deleteModalId, role: "dialog" }
            },
            [
              _c("div", { staticClass: "modal-dialog" }, [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-body" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("p", { staticClass: "cancel-warning" }, [
                      _vm._v(
                        "\n              Do you want to delete the prize\n              "
                      ),
                      _c("span", { staticStyle: { "font-weight": "600" } }, [
                        _vm._v(_vm._s(this.prize.name))
                      ]),
                      _vm._v("?\n            ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-btn-container" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-default spin",
                          on: {
                            click: function($event) {
                              return _vm.dismissDeleteModal()
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-danger",
                          on: {
                            click: function($event) {
                              return _vm.deletePrize()
                            }
                          }
                        },
                        [_vm._v("Delete")]
                      )
                    ])
                  ])
                ])
              ])
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.deleted && this.prize.deletedAt != null
      ? _c("div", { staticClass: "flex-table-row d-flex align-items-center" }, [
          _c(
            "div",
            {
              staticClass: "column c-prize-name",
              style: {
                textDecoration:
                  this.prize.status == "drawn" ? "underline" : "none",
                cursor: this.prize.status == "drawn" ? "pointer" : "auto"
              }
            },
            [_vm._v(_vm._s(this.prize.name))]
          ),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "column c-list block-with-text mobile",
              attrs: {
                title: this.prize.lists
                  .map(function(i) {
                    return i.name
                  })
                  .join(", ")
              }
            },
            [
              _vm._v(
                _vm._s(
                  this.prize.lists
                    .map(function(i) {
                      return i.name
                    })
                    .join(", ")
                )
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "column c-winners mobile" }, [
            _vm._v(_vm._s(this.prize.winnerCount))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column type-date c-created mobile" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.formatDate(this.prize.createdAt)) +
                "\n      "
            ),
            _c("span", [_vm._v(_vm._s(_vm.formatTime(this.prize.createdAt)))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column type-date c-modified mobile" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.formatDate(this.prize.updatedAt)) +
                "\n      "
            ),
            _c("span", [_vm._v(_vm._s(_vm.formatTime(this.prize.updatedAt)))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column c-modified-by mobile" }, [
            _c("div", [_vm._v(_vm._s(this.prize.author.gevmeUser.firstname))]),
            _vm._v(" "),
            _c("div", { staticStyle: { "margin-top": "7px" } }, [
              _vm._v(_vm._s(this.prize.author.gevmeUser.email))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column c-action" }, [
            _c("div", { staticClass: "btn-group" }, [
              _vm._m(4),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "dropdown-menu dropdown-menu-right prize-list-actions"
                },
                [
                  this.prize.drawn
                    ? _c(
                        "button",
                        {
                          staticClass: "dropdown-item",
                          on: {
                            click: function($event) {
                              return _vm.viewDrawSummary()
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: { src: require("@/assets/images/eye.svg") }
                          }),
                          _vm._v("\n            View Draw Summary\n          ")
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          return _vm.duplicatePrize()
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: { src: require("@/assets/images/duplicate.svg") }
                      }),
                      _vm._v("\n            Duplicate Prize\n          ")
                    ]
                  ),
                  _vm._v(" "),
                  this.prize.drawn
                    ? _c(
                        "button",
                        {
                          staticClass: "dropdown-item",
                          on: {
                            click: function($event) {
                              return _vm.exportAttendees(_vm.prize)
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/images/export.svg")
                            }
                          }),
                          _vm._v("\n            Export Attendees\n          ")
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          return _vm.goToAuditHistory(
                            _vm.prize.id,
                            _vm.prize.name
                          )
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/images/audit-history.svg")
                        }
                      }),
                      _vm._v("\n            Audit History\n          ")
                    ]
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "modal fade",
              attrs: { id: _vm.deleteModalId, role: "dialog" }
            },
            [
              _c("div", { staticClass: "modal-dialog" }, [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-body" }, [
                    _vm._m(5),
                    _vm._v(" "),
                    _c("p", { staticClass: "cancel-warning" }, [
                      _vm._v(
                        "\n              Do you want to delete the prize\n              "
                      ),
                      _c("span", { staticStyle: { "font-weight": "600" } }, [
                        _vm._v(_vm._s(this.prize.name))
                      ]),
                      _vm._v("?\n            ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-btn-container" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-default spin",
                          on: {
                            click: function($event) {
                              return _vm.dismissDeleteModal()
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-danger",
                          on: {
                            click: function($event) {
                              return _vm.deletePrize()
                            }
                          }
                        },
                        [_vm._v("Delete")]
                      )
                    ])
                  ])
                ])
              ])
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-secondary dropdown-toggle",
        attrs: { type: "button", "data-toggle": "dropdown" }
      },
      [
        _vm._v("\n          Start Draw\n          "),
        _c("span", { staticClass: "caret" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn dropdown-toggle",
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }
      },
      [
        _c("img", {
          staticClass: "menu-vertical",
          attrs: { src: require("@/assets/images/menu_vertical.svg") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h2", [_vm._v("Are you Sure?")]),
      _vm._v(" "),
      _c("img", {
        staticClass: "header-action modal-close",
        attrs: {
          src: require("@/assets/images/x.svg"),
          "data-dismiss": "modal"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column c-status" }, [
      _c(
        "div",
        { staticClass: "alert alert-danger", attrs: { role: "alert" } },
        [_vm._v("Deleted")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn dropdown-toggle",
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }
      },
      [
        _c("img", {
          staticClass: "menu-vertical",
          attrs: { src: require("@/assets/images/menu_vertical.svg") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h2", [_vm._v("Are you Sure?")]),
      _vm._v(" "),
      _c("img", {
        staticClass: "header-action modal-close",
        attrs: {
          src: require("@/assets/images/x.svg"),
          "data-dismiss": "modal"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-acd65344", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-acd65344","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrizeTableRow.vue
// module id = null
// module chunks = 